<template>
  <div class="modal-content" :class="`${isFixedOnTop ? 'ofFixedOnTop' : ''}`">
    <div class="modal-header justify-content-between align-items-center bg-light px-2 py-1">
      <div class="flex-grow-1 w-0 text-truncate">
        <ul class="list-inline mb-0 d-flex align-items-center text-truncate">
          <li class="list-inline-item mx-0 pr-0 pr-md-2 border-right">
            <button type="button" class="btn btn-light text-secondary d-flex" @click="onClose">
              <i class="pz-icon icon-cancelmr-1"></i>
              <span class="d-none d-md-inline-block">关闭</span>
            </button>
          </li>
          <li class="list-inline-item ml-2 ml-md-3 text-truncate">
            <h5 class="modal-title text-truncate f-xs-14">{{ title }}</h5>
          </li>
        </ul>
      </div>
      <!-- <h5 class="modal-title text-center">{{ title }}</h5> -->

      <ul class="list-inline mb-0">
        <!-- <li class="list-inline-item mx-0 mx-lg-2">
          <div class="dropdown">
            <a
              class="btn btn-light text-secondary d-flex flex-column"
              href="#"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="material-icons">toggle_off</i>
              <small>设置</small>
            </a>
            <form class="dropdown-menu dropdown-menu-right p-4 shadow-lg w-200">
              <div class="pb-3">
                <p class="mb-2">更改文字大小</p>
                <div class="btn-group btn-group-toggle btn-group-font" data-toggle="buttons">
                  <label
                    class="btn btn-light text-muted btn-group-font-sm"
                    :class="{active: fontSize=== 1}"
                    @click="setFontSize(1)"
                  >
                    <input
                      type="radio"
                      name="options"
                      id="option1"
                      autocomplete="off"
                      :value="1"
                      v-model="fontSize"
                    /> 小
                  </label>
                  <label
                    class="btn btn-light text-muted btn-group-font-default"
                    :class="{active: fontSize=== 2}"
                    @click="setFontSize(2)"
                  >
                    <input
                      type="radio"
                      name="options"
                      :value="2"
                      v-model="fontSize"
                      id="option2"
                      autocomplete="off"
                    /> 中
                  </label>
                  <label
                    class="btn btn-light text-muted btn-group-font-lg"
                    :class="{active: fontSize=== 3}"
                    @click="setFontSize(3)"
                  >
                    <input
                      :value="3"
                      v-model="fontSize"
                      type="radio"
                      name="options"
                      id="option3"
                      autocomplete="off"
                    /> 大
                  </label>
                </div>
              </div>
              <div class="dropdown-divider"></div>
              <div class="pt-2">
                <div class="custom-control custom-switch">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    v-model="hasMuted"
                    id="customSwitch2"
                  />
                  <label
                    class="custom-control-label"
                    for="customSwitch2"
                  >{{hasMuted?"关闭": "打开"}}答题音效</label>
                </div>
              </div>
            </form>
          </div>
        </li>-->
        <li class="list-inline-item mx-0 mx-lg-2">
          <button
            type="button"
            class="btn btn-light text-secondary d-flex flex-column"
            @click="onResizeModal"
          >
            <i
              class="pz-icon"
              :class="`${isFullscreen ? 'icon-fullscreen-exit' : 'icon-fullscreen'}`"
            ></i>
            <small class="d-none d-md-inline-block">全屏</small>
          </button>
        </li>
      </ul>
    </div>
    <div class="modal-body p-0 bg-white" style="height: 500px">
      <div class="loading-spinner">
        <Spinner displayType="fixed" text="加载中 ..." questionClass="question" />
      </div>
    </div>
  </div>
</template>
<script>
import Spinner from '../Spinner.vue';

export default {
  name: 'Loading',

  props: {
    isFullscreen: Boolean,
    onResizeModal: Function,
    title: String,
    content: {
      type: Array,
      default: () => [],
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    isFixedOnTop: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    Spinner,
  },

  methods: {
    doFilter() {
      this.onFilter();
    },
  },
};
</script>
<style scoped lang="scss">
.loading-spinner {
  position: absolute;
  // height: 100%;
  width: 100%;
  left: 0;
  right: 0;
  top: 72px;
  bottom: 0;
}
.ofFixedOnTop {
  position: fixed;
  z-index: 10000;
}
</style>
